module.exports = __webpack_public_path__ + "static/media/webpack.ff049adb.png";